import helper from 'helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('ordini');
export const actions = helper.createActions('ordini', actionTypes);
